
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";

import {
    Card, CardHeader, CardContent, ButtonGroup, Button, CardActions, Box, Collapse, Alert, IconButton, Breadcrumbs, Link,
} from '@mui/material';

import { Can } from "@casl/react";
import { Ability } from "@casl/ability";
import jwt_decode from "jwt-decode";
import { esES } from '@mui/x-data-grid';
import { DataGrid, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarFilterButton, gridClasses } from "@mui/x-data-grid";
import CloseIcon from '@mui/icons-material/Close';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import FolderCopyTwoToneIcon from '@mui/icons-material/FolderCopyTwoTone';

const CustomToolbar = (props) => (
    <GridToolbarContainer {...props}>
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
    </GridToolbarContainer>
);

export default function PartidasLista() {
    const [partidas, setPartidas] = useState([])
    const [loading, setLoading] = useState(false)
    const [openMensaje, setOpenMensaje] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [pageSize, setPageSize] = useState(10)
    const [data, setData] = useState({ columns: [], rows: [] })
    const [severity, setSeverity] = useState('error')

    const token = sessionStorage.getItem('token')
    const decoded = jwt_decode(token);
    const idResponsable = decoded.id;
    const obtenerReglas = () => {
        let reglas
        const perfilElegido = sessionStorage.getItem('perfilElegido')
        switch (perfilElegido) {
            case 'asistente':
                reglas = decoded.rulesAsistente
                break
            case 'investigador':
                reglas = decoded.rulesJefaturaArea
                break
            case 'coordinacion':
                reglas = decoded.rulesCoordinacion
                break
            case 'jefe':
                reglas = decoded.rulesJefatura
                break
            case 'administracion':
                reglas = decoded.rulesAdministracionProyecto
                break
            default:
                break
        }
        return reglas
    }
    let reglas = decoded.rules
    if (!reglas)
        reglas = obtenerReglas()
    const ability = new Ability(reglas);

    const navigate = useNavigate()
    const [ocultarAcciones, setOcultarAcciones] = useState(Boolean(false))
    const verificarAcciones = () => {
        for (let i = 0; i < reglas.length; i++) {

            if (reglas[i].action === 'manage' && reglas[i].subject === 'partidaCatalogo') {
                setOcultarAcciones(Boolean(true))
                return
            }

        }
    }

    const cargarPartidas = async () => {
        const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidas`)
        const data = await res.json()
        //console.log(`PARTIDAS EN PartidasLista ${data}`)
        setPartidas(data)

        const datos = {
            columns: [
                {
                    field: "clave", flex: 0.2, headerName: "Clave", hide: false, sortable: true, filterable: true, type: "numeric", hideable: false
                },

                {
                    field: "concepto", flex: 0.6, align: 'left', sortable: false, filterable: true, type: "string",
                    headerName: 'Concepto', hideable: false
                },
                {
                    field: "id", flex: 0.2, align: 'left', sortable: false, filterable: false, hideable: true,
                    headerName: 'Acciones',
                    renderCell: ({ value }) => (
                        <ButtonGroup disableElevation variant="outlined" color="primary">
                            <Can I="update" a="partidaCatalogo" ability={ability}>
                                <Button variant='contained' color='inherit' onClick={() => navigate(`/partidas/${value}/editar`)}>Editar</Button>
                            </Can>
                            <Can I="delete" a="partidaCatalogo" ability={ability}>
                                <Button variant='contained' style={{ marginLeft: 5, backgroundColor: "darkred", color: 'white' }} onClick={() => handleDelete(value)} disabled={loading}>Eliminar</Button>
                            </Can>
                        </ButtonGroup>
                    ),
                }
            ], rows: data

        }
        setData(datos)
    }

    const handleDelete = async (id) => {
        setLoading(true)
        try {
            const res = await fetch(`http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/partidas/${id}`, {
                method: "DELETE",
                headers: {
                    "x-access-token": sessionStorage.getItem('token'),
                    "perfil": sessionStorage.getItem('perfil')
                }
            })
            if (res.status === 403) {
                setOpenMensaje(true)
                setSeverity('warning')
                setMensaje(`La sesión ha expirado, cierre su sesión (Botón LOGOUT) y vuelva a loguearse`)
                return
            }
            //setPartidas(partidas.filter(partidas => partidas.id !== id))
            // setData(partidas.filter(partidas => partidas.id !== id))
            await cargarPartidas()
        } catch (error) {
            console.error(error)
        }
        setLoading(false)
    }


    useEffect(() => {
        (async () => {
            verificarAcciones()
            await cargarPartidas()
        })();
    }, []
    )

    return (
        <>
            {
                <div role="presentation" style={{ marginTop: '20px' }} >
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link
                            underline="hover"
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color="inherit"
                            href={`/proyectosInforme/${idResponsable}/true`}
                        >
                            <FolderCopyTwoToneIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            Informe
                        </Link>
                        <Link
                            underline="hover"
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color="inherit"
                            href="javascript:void(0)" onClick={() => { navigate(-1) }}
                        >
                            <KeyboardReturnIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                            Regresar
                        </Link>
                    </Breadcrumbs>
                </div>}
            <div style={{ display: 'flex', marginTop: '50px' }}>
                <Card style={{ height: '100%', width: '100%' }}>

                    <CardHeader title='Listado de partidas'></CardHeader>
                    <CardActions>
                        <Can I="create" a="partidaCatalogo" ability={ability}>
                            <Button variant='contained' style={{ backgroundColor: "darkgreen", color: 'white', position: "relative", left: '20px' }} onClick={() => navigate("/partidas/agregar")}>Agregar</Button>
                            <Button size="small" style={{ position: "relative", left: '40px' }} onClick={() => window.open("https://transparencia.uam.mx/presupuesto/presup2017/CLASIFICADORXOBJETO_D_GASTO100217febrero-2017.pdf")}>Consultar CLASIFICADOR POR OBJETO DEL GASTO SUBESPECÍFICO</Button>
                        </Can>
                    </CardActions>
                    <CardContent>
                        <Box sx={{ width: '100%' }}>
                            <Collapse in={openMensaje}>
                                <Alert severity={severity}
                                    action={
                                        <IconButton
                                            aria-label="close"
                                            color="inherit"
                                            size="small"
                                            onClick={() => {
                                                setOpenMensaje(false);
                                            }}
                                        >
                                            <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                    }
                                    style={{ marginTop: 30 }}
                                >
                                    {mensaje}
                                </Alert>
                            </Collapse>
                        </Box>
                        <DataGrid {...data} pageSize={pageSize} autoHeight getRowHeight={() => 'auto'} getRowId={(row) => row.id} sx={{
                            [`& .${gridClasses.cell}`]: {
                                py: 1,
                            },
                            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
                            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
                            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
                        }}

                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} rowsPerPageOptions={[5, 10, 15]} localeText={esES.components.MuiDataGrid.defaultProps.localeText} components={{ Toolbar: CustomToolbar }}>

                        </DataGrid>
                    </CardContent>

                </Card>
            </div>

        </>
    );
}